import { PrimitiveValueObjectDateTime } from '@/domain/primitiveValueObjectDateTime';

/**
 * 遅刻日時
 */
export class LateDateTime extends PrimitiveValueObjectDateTime {
  /**
   * 作成
   * @param value 値
   * @returns 値
   */
  static create(value: Date): LateDateTime {
    return new LateDateTime(value);
  }

  /** ラベル日 */
  static get labelDate(): string {
    return '遅刻日';
  }

  /** ラベル時間 */
  static get labelTime(): string {
    return '到着予定時刻';
  }

  /**
   * バリデーションルール
   */
  static get validationRuleDate() {
    return {
      /** 必須 */
      required: '必須項目です',
      /** バリデーション */
      validate: {
        /** メッセージ */
        message: (v: string) => {
          const now = new Date();
          const tmp = v.split('-');
          const num = parseInt(`${tmp[0]}${tmp[1]}${tmp[2]}`, 10);
          let numNow = now.getFullYear() * 10000;
          numNow += (now.getMonth() + 1) * 100;
          numNow += now.getDate();
          if (num < numNow) {
            return '過去の連絡はできません';
          }
          return null;
        },
      },
    };
  }

  /** バリデーションルール時間 */
  static get validationRuleTime() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /**
   * 比較日より前かチェックします.
   * @param date 比較日
   * @returns 比較日より前か
   */
  isPastDate(date: Date) {
    let valueNum = this.value.getFullYear() * 10000;
    valueNum += this.value.getMonth() * 100;
    valueNum += this.value.getDate();
    let dateNum = date.getFullYear() * 10000;
    dateNum += date.getMonth() * 100;
    dateNum += date.getDate();
    return valueNum < dateNum;
  }
}
